

<div class="grid">
    <div class="col-12">
      <div class="card">
        <iframe
            [src]="iframeUrl"
            frameborder="0"
            style="width: 100%;
            height: 1000px;"
            allowtransparency
        ></iframe>
  
      </div>
    </div>
  </div>
